module.exports = __webpack_public_path__ + "static/power-img2-3@2x-988020c12d041227ae533ae7ba642128.png";